import apiClient from '../clients/apiClient';

export interface FdRenewalInstitute {
    name_ln1?: string | null;
    name_ln2?: string | null;
    name_ln3?: string | null;
    address_ln1?: string | null;
    address_ln2?: string | null;
    phone?: string | null;
    logo?: string | null;
}

export interface FdRenewalBranch {
    name_ln1?: string | null;
    name_ln2?: string | null;
    telephone?: string | null;
}

export interface FdRenewalCustomer {
    customer_number?: string | null;
    ini_name_ln1?: string | null;
    ini_name_ln2?: string | null;
    ini_name_ln3?: string | null;
    full_name_ln1?: string | null;
    full_name_ln2?: string | null;
    address_ln1?: string | null;
    address_ln2?: string | null;
    address_ln3?: string | null;
}

export interface FdPreviousPeriod {
    account_number?: string | null;
    branch_name_ln1?: string | null;
    branch_name_ln2?: string | null;
    deposit_amount?: number | null;
    maturity_date?: string | null;
    interest_rate?: number | null;
    period?: number | null;
    interest?: number | null;
    tax?: number | null;
    net_interest?: number | null;
}

export interface FdRenewalDetails {
    account_number?: string | null;
    current_value?: number | null;
    period?: number | null;
    interest_rate?: number | null;
    interest_at_maturity?: number | null;
    renew_date?: string | null;
    branch_telephone?: string | null;
}

export interface FdRenewalLetterResponse {
    institute?: FdRenewalInstitute | null;
    branch?: FdRenewalBranch | null;
    customer?: FdRenewalCustomer | null;
    previous?: FdPreviousPeriod | null;
    renewal?: FdRenewalDetails | null;
}

export const getFdRenewalLetter = async (accountId: number): Promise<FdRenewalLetterResponse | null> => {
    try {
        const response = await apiClient.get(`/fd-update/renewal-letter`, { params: { account_id: accountId } });
        return response.data.data || null;
    } catch (error) {
        return null;
    }
};